import OperatorView from "../../Components/OperatorManagement/viewOperator";

export default function OperatorViewandUser(){
    return(
        <OperatorView/>
    )
}